import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Icon, Button } from 'Components';
import './InvoicesListMobileAccordion.css';
import InvoicesListMobileItemBody from '../InvoicesListMobileItemBody/InvoicesListMobileItemBody';

const InvoicesMobileAccordion = ({
  data,
  index,
  onExpandClick,
  onMenuClick,
  handleMenuRowClick,
  expanded,
  setInvoiceMobileState,
}) => (
  <div className={`invoices-list-mobile-accordion ${expanded ? 'invoices-list-mobile-accordion--active' : ''}`}>
    <div className="invoices-list-mobile-accordion__container">
      <div className="invoices-list-mobile-accordion__container__content">
        <div>{i18n.t('invoices:Invoice')}: {data.InvoiceNumber}</div>
        <div>{i18n.t('invoices:Invoice Date')}: {data.InvoiceDate}</div>
        <div>
          <div>{i18n.t('invoices:Balance Due')}: ${data.AmountRemaining}</div>
        </div>
      </div>
      <Button onClick={onExpandClick}>
        <Icon icon={expanded ? 'chevron_left' : 'chevron_right'} rotate={90} />
      </Button>
    </div>
    {
      expanded &&
        <InvoicesListMobileItemBody
          index={index}
          data={data}
          handleMenuRowClick={handleMenuRowClick}
          setInvoiceMobileState={setInvoiceMobileState}
          onMenuClick={onMenuClick}
        />
    }
  </div>
);

InvoicesMobileAccordion.propTypes = {
  index: PropTypes.number,
  onMenuClick: PropTypes.func,
  data: PropTypes.shape({
    Description: PropTypes.string,
    Pinned: PropTypes.bool,
  }),
  expanded: PropTypes.bool,
  onExpandClick: PropTypes.func,
  handleMenuRowClick: PropTypes.func,
  setInvoiceMobileState: PropTypes.func,
};

InvoicesMobileAccordion.defaultProps = {
  onExpandClick: () => null,
};

export default InvoicesMobileAccordion;



// WEBPACK FOOTER //
// ./src/containers/Invoices/InvoicesList/InvoicesListMobile/InvoicesListMobileAccordion/InvoicesListMobileAccordion.jsx